import { SerproConfigProps } from "./Serpro.type";

export const SerproConfig: SerproConfigProps = {
    url: process.env.REACT_APP_MEI_PENDENCIAS_API_URL,
    cnpj: process.env.REACT_APP_FAC_CNPJ
};

export default SerproConfig;
